import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import PageMeta from '../components/PageMeta';
import { getStorageUrl } from '../services/api';
import { fetchPeople } from '../services/people';
import './PeopleInvolved.css';

const PeopleInvolved = () => {
  const [people, setPeople] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    const loadPeople = async () => {
      try {
        setLoading(true);
        setError('');
        const data = await fetchPeople();
        if (!cancelled) setPeople(data);
      } catch (err) {
        if (!cancelled) {
          setPeople([]);
          setError(err.response?.data?.message || 'Failed to load our people. Please try again later.');
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadPeople();
    return () => { cancelled = true; };
  }, []);

  return (
    <Layout>
      <PageMeta
        title="People Involved"
        description="Meet the people helping FM Ultratech Farms deliver trusted agricultural products and services."
      />
      <div className="people-page">
        <section className="people-hero">
          <div className="people-container">
            <p className="people-eyebrow">The people behind our work</p>
            <h1>People <span>Involved</span></h1>
            <p className="people-hero-copy">
              Meet the dedicated professionals driving FM Ultratech Farms forward and supporting our customers.
            </p>
          </div>
        </section>

        <section className="people-section">
          <div className="people-container">
            <div className="people-section-heading">
              <h2>Our Team</h2>
              <p>The experience, care, and commitment behind everything we do.</p>
            </div>

            {loading ? (
              <p className="people-status">Loading our team...</p>
            ) : error ? (
              <p className="people-status people-status--error">{error}</p>
            ) : people.length === 0 ? (
              <p className="people-status">Team profiles will be added soon.</p>
            ) : (
              <div className="people-grid">
                {people.map((person) => (
                  <article className="person-card" key={person.id}>
                    <div className="person-image-wrap">
                      <img src={getStorageUrl(person.image)} alt={person.name} className="person-image" />
                    </div>
                    <div className="person-content">
                      <h3>{person.name}</h3>
                      <p className="person-title">{person.title}</p>
                      <p className="person-description">{person.description}</p>
                    </div>
                  </article>
                ))}
              </div>
            )}
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default PeopleInvolved;
